import { getListSelectedFeatures, map } from './map/tools';

import GeoJSON from 'ol/format/GeoJSON';
import GML32 from 'ol/format/GML32';
import { jsPDF } from 'jspdf';
import { autoTable } from 'jspdf-autotable'

const saveURI = (uri, filename) => {
  // if (filename !== 'utslipp.png') return;
  // Download it
  const link = document.createElement('a');
  link.style.display = 'none';
  // link.target = '_blank';
  link.href = uri;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  // setTimeout(() => link.click(), Math.round(Math.random() * 1000)); // webkit fix
  document.body.removeChild(link);
};

const mime = {
  csv: 'text/csv',
  geojson: 'application/geo+json',
  geotiff: 'image/tiff;application=geotiff',
  gml: 'application/gml+xml',
  png: 'image/png',
  pdf: 'application/pdf'
};

const getURI = (txt, type) => {
  return `data:${mime[type]};charset=utf-8,${encodeURIComponent(txt)}`;
};

const saveCsv = (csv, filename) => saveURI(getURI(csv, 'csv'), filename);

const saveGeoJSON = (tif, name) => saveURI(getURI(tif, 'geojson'), name);

const saveGeoTiff = (tif, name) => saveURI(getURI(tif, 'geotiff'), name);

const saveGml = (gml, filename) => saveURI(getURI(gml, 'gml'), filename);

const dpi = 150; // 72, 150, 300
const mmToPx = (mm) => Math.round((mm * dpi) / 25.4);
const pxToMm = (px) => Math.round(px * 25.4 / dpi);
const replaceInTable = (id, from, to) => {
  // const t = document.getElementById(id).cloneNode(true); // misses css on pdf
  const t = document.getElementById(id);
  const rows = t?.rows;
  const nrows = rows?.length;
  for (let i = 0; i < nrows; i++) {
    const r = rows[i];
    const cells = r.cells;
    const ncells = cells.length;
    for (let j = 0; j < ncells; j++) {
      const c = cells[j];
      c.innerHTML = c.innerHTML.replace(from, to);
    }
  }
  return t;
};

const savePdf = (csv, filename) => {
  const marginMm = [10, 10]
  const marginPx = marginMm.map(mmToPx);
  const pageMm = [297, 210];
  const mapPx = map.getSize();
  const maxMm = [pageMm[0] - marginMm[0] * 2, pageMm[1] - marginMm[1] * 3];
  const imageMm = [];
  const ratioP = maxMm[0] / maxMm[1];
  const ratioI = mapPx[0] / mapPx[1];
  if (ratioP > ratioI) { // strech height to max and width according to ratio
    imageMm[0] = maxMm[1] * ratioI;
    imageMm[1] = maxMm[1];
  } else { // stretch width to max and height according to page ratio
    imageMm[0] = maxMm[0];
    imageMm[1] = maxMm[0] / ratioI;
  }
  const offset = [
    (pageMm[0] - imageMm[0]) / 2,
    (pageMm[1] - imageMm[1] + 10) / 2
  ];
  map.once('rendercomplete', () => {
    const pdf = new jsPDF('landscape', undefined, 'a4');
    // pdf.text(108, 10, 'Klimagasskalkulator - NIBIO');
    const title = `
      Beregning av utslipp og opptak fra arealbruk og arealbruksendringer \
      \t\t\t NIBIO - ${new Date().toLocaleDateString('nb')}
    `;
    pdf.text(8, 10, title);
    pdf.addImage(
      exportMap(map), 'JPEG', offset[0], offset[1], imageMm[0], imageMm[1]
    );
    pdf.addPage();
    const x = 10;
    let y = 10; // keep track of relative height position, start with margin
    let t;
    const classes = document.getElementById('resultsContent').classList;
    const lineHeight = 0.9 * pdf.getLineHeight() / pdf.internal.scaleFactor;
    pdf.textWithLink(
      'Klikk her for å lese NIBIOs ansvarsbegrensning for bruk av kalkulatoren',
      x + 52, y,
      { url: 'https://www.nibio.no/tjenester/kartbasert-klimagasskalkulator-for-arealbrukssektoren/ansvarsbegrensning' }
    );
    y += lineHeight + 4;
    if (classes.contains('openComparedEmissions')) {
      pdf.text('- Estimert samlet effekt av tiltaket', x, y);
      y += lineHeight - 4;
      t = replaceInTable('comparedEmissions', '−', '-');
      autoTable(pdf, { html: t, useCss: true, startY: y });
      replaceInTable('comparedEmissions', '-', '−');
      y += (t.rows.length + 1) * lineHeight;
    }
    if (classes.contains('opened')) {
      pdf.text('- Estimert utslipp per i dag', x, y);
      y += lineHeight - 4;
      t = replaceInTable('currentEmissions', '−', '-');
      autoTable(pdf, { html: t, useCss: true, startY: y });
      replaceInTable('currentEmissions', '-', '−');
      y += (t.rows.length + 1) * lineHeight + 2;
    }
    pdf.text('- Estimert utslipp som følge planen', x, y);
    y += lineHeight - 4;
    // autoTable(pdf, { html: '#plannedEmissions', useCss: true });
    t = replaceInTable('plannedEmissions', '−', '-');
    autoTable(pdf, { html: t, useCss: true, startY: y  });
    replaceInTable('plannedEmissions', '-', '−');
    pdf.save(filename);
    //// Reset original map size
    //map.setSize(size);
    //map.getView().setResolution(viewResolution);
  });
  map.renderSync();
};

const savePng = (nodata, filename) => {
  map.once('rendercomplete', () => saveURI(exportMap(map), filename));
  map.renderSync();
};

const save = {
  'csv': saveCsv,
  'geojson': saveGeoJSON,
  'geotiff': saveGeoTiff,
  'gml': saveGml,
  'pdf': savePdf,
  'png': savePng,
  'tiff': saveGeoTiff,
  'tif': saveGeoTiff
};

export const saveToFile = (data, filename) => {
  const ext = filename.slice(filename.lastIndexOf('.') + 1);
  save[ext](data, filename);
};

const plans = ['RbFormålOmråde', 'RpArealformålOmråde', 'KpArealformålOmråde'];
const boundingAreas = ['RpOmråde', 'KpOmråde'];
const plansAndTheirBoundingAreas = plans.concat(boundingAreas);

const ns = 'https://skjema.geonorge.no/SOSI/produktspesifikasjon';
const format = new GML32({
   // featureNS: { app: ns },
   featureNS: 'plan',
   featureType: 'featureMember',
   // featureType: ['app:arealtype'],
   // featureType: ['app:RpArealformålOmråde'],
   // featureType: ['app:RbFormålOmråde'],
   // featureType: plans.map(p => `app:${p}`),
   // srsName: 'urn:ogc:def:crs:EPSG::25833',
   srsName: 'EPSG:25833',
   // schemaLocation: `${ns} ${ns}/reguleringsplan_20190401.xsd`
   schemaLocation: `${ns}/Reguleringsplan/20190401/reguleringsplan_20190401.xsd`
});

const getKommune = id => {
  const rows = comparedEmissions.tBodies[0].rows;
  for (let i = 0; i < rows.length; i++) {
    const tr = rows[i];
    // console.log(tr.cells[0].innerHTML, tr.cells[1].innerHTML, id);
    if (tr.cells[0].innerHTML === id) return tr.cells[1].innerHTML;
  };
  return undefined;
};

export const saveGeometryToFile = () => {
  const filteredFeatures = getListSelectedFeatures();
  filteredFeatures.forEach(f => {
    const planid = f.get('planid');
    const plantegn = f.get('title');
    if (plantegn !== planid) { // redigert plantegn, planid er den opprinnelige
      f.set('planid', plantegn);
      f.set('feltbetegnelse', undefined);
    }
    f.set('title', undefined);
    f.set('fremtidigBruk', f.get('fremtidig'));
    f.set('fremtidig', undefined);
    f.set('plankategori', undefined);
    if (!f.get('kommunenummer')) f.set('kommunenummer', getKommune(plantegn));
    f.set('ksys', 'WGS84');
  });
  if (filteredFeatures.length > 0) {
    saveToFile(new GeoJSON().writeFeatures(filteredFeatures, {
      // dataProjection: 'EPSG:4326',
      featureProjection: 'EPSG:25833',
      rightHanded: true,
      // decimals: 1
    }), 'plan.geojson');
    // GML writer fails when a property name contains spaces.
    // RpOmråde has "LINK https", place an underscore instead:
    filteredFeatures.forEach(f => {
      Object.keys(f.getProperties()).forEach(k => {
        if (k.indexOf(' ') > -1) {
          f.set(k.replaceAll(' ', '_'), f.get(k));
          f.unset(k);
        }
        if (f.get(k) === undefined) f.unset(k); // writeFeatures fails if undef
      });
    });
    const gml = format.writeFeatures(filteredFeatures, {
      // featureProjection: 'EPSG:25833',
      rightHanded: true,
      decimals: 1
    });
    // saveToFile(gml, 'plan.gml');
  }
};

const exportMap = (map) => {
  const mapCanvas = document.createElement('canvas');
  const size = map.getSize();
  mapCanvas.width = size[0];
  mapCanvas.height = size[1];
  const mapContext = mapCanvas.getContext('2d');
  Array.prototype.forEach.call(
    map.getViewport().querySelectorAll('.ol-layer canvas, canvas.ol-layer'),
    canvas => {
      if (canvas.width > 0) {
        const opacity =
          canvas.parentNode.style.opacity || canvas.style.opacity;
        mapContext.globalAlpha = (opacity === '') ? 1 : Number(opacity);
        let matrix;
        const transform = canvas.style.transform;
        if (transform) {
          // Get the transform parameters from the style's transform matrix
          matrix = transform
            .match(/^matrix\(([^\(]*)\)$/)[1]
            .split(',')
            .map(Number);
        } else {
          matrix = [
            parseFloat(canvas.style.width) / canvas.width, 0, 0,
            parseFloat(canvas.style.height) / canvas.height, 0, 0
          ];
        }
        // Apply the transform to the export map context
        CanvasRenderingContext2D.prototype.setTransform.apply(
          mapContext, matrix
        );
        const backgroundColor = canvas.parentNode.style.backgroundColor;
        if (backgroundColor) {
          mapContext.fillStyle = backgroundColor;
          mapContext.fillRect(0, 0, canvas.width, canvas.height);
        }
        mapContext.drawImage(canvas, 0, 0);
      }
    }
  );
  mapContext.globalAlpha = 1;
  mapContext.setTransform(1, 0, 0, 1, 0, 0);
  return mapCanvas.toDataURL();
};
